import React, { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  query,
  orderBy,
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore";

import {
  useNavigate,
  useLocation,
} from "react-router-dom";

import { useAuth, db } from "../context/authContext";
import toast from "react-hot-toast";
import logo from "../assets/Logo.png";
import { volverAClase } from "../utils/navigation";

const MENSAJES = [
  "💣 Lo que no hagas ahora, ¡no lo harás nunca!",
  "🔥 Cuando más comas, más tendrás que entrenar!",
  "💤 Descansa... que luego nos veremos en la bici!",
  "🚴‍♂️ Deja el sofá, que aquí se gana en el pedaleo!",
  "💪 Hoy sudas, mañana brillas!",
  "🥵 Si no duele, no sirve!",
  "🏆 El podio no espera a los flojos!",
  "⏱️ El tiempo corre... ¿y tú?",
  "🍔 Cada hamburguesa pesa en tus RPM!",
  "⚡ Dale caña, que la vida no tiene replay!",
];

const Ranking = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [mesActual, setMesActual] = useState("");

  const navigate = useNavigate();

  const location = useLocation();

  const tipoRanking =
    location.state?.tipoRanking || "global";
  const { logout, EstadoLogout, addInfoGym, user } = useAuth();

  // Gimnasio o canal actual
  const gimnasioActual =
    JSON.parse(localStorage.getItem("gimnasio")) || "";

  const handleLogout = async () => {
    try {
      await addInfoGym("");
      localStorage.removeItem("gimnasio");
      await EstadoLogout();

      localStorage.setItem("logout", Date.now());

      await logout();

      console.log("✅ Logout completo y propagado desde Ranking");
    } catch (error) {
      console.error("❌ Error en logout:", error);
    }
  };

  const handleClase = async () => {
    try {
      localStorage.removeItem("gimnasio");
      await EstadoLogout();
      navigate("/Comprobacion");
    } catch (error) {
      console.error("❌ Error al volver al listado:", error);
    }
  };

  // Validar que estoy en ranking
  useEffect(() => {
    localStorage.setItem("lastPage", "ranking");
  }, []);

  // Cargar usuarios del gimnasio actual
  useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        const fecha = new Date();

        const nombreMes = new Intl.DateTimeFormat("es-ES", {
          month: "long",
        }).format(fecha);

        const mesHoy =
          nombreMes.charAt(0).toUpperCase() +
          nombreMes.slice(1);

        setMesActual(mesHoy);

        // Documento global del ranking mensual
        const rankingRef = doc(
          db,
          "config",
          "rankingMensual"
        );

        const rankingSnap = await getDoc(rankingRef);

        let mesActivo = mesHoy;

        if (!rankingSnap.exists()) {
          await setDoc(rankingRef, {
            mesActivo: mesHoy,
            updatedAt: Date.now(),
          });

          mesActivo = mesHoy;
        } else {
          const rankingData = rankingSnap.data();

          if (rankingData.mesActivo !== mesHoy) {
            await setDoc(
              rankingRef,
              {
                mesActivo: mesHoy,
                updatedAt: Date.now(),
              },
              { merge: true }
            );

            mesActivo = mesHoy;
          } else {
            mesActivo =
              rankingData.mesActivo || mesHoy;
          }
        }

        // Cargar usuarios
        const usuariosRef = collection(db, "usuarios");

        const q = query(
          usuariosRef,
          orderBy("puntosTotales", "desc")
        );

        const usuariosSnapshot = await getDocs(q);

        let usuariosData = usuariosSnapshot.docs.map(
          (docSnap) => {
            const data = docSnap.data();

            const puntosTotales =
              data.mesReseteado === mesActivo
                ? data.puntosTotales || 0
                : 0;

            return {
              id: docSnap.id,
              ...data,
              puntosTotales,
            };
          }
        );

        // Solo filtrar cuando venimos desde una clase
        if (tipoRanking === "grupo") {
          usuariosData = usuariosData.filter(
            (usuario) =>
              usuario.nombreGym === gimnasioActual
          );
        }

        usuariosData.sort(
          (a, b) =>
            (b.puntosTotales || 0) -
            (a.puntosTotales || 0)
        );

        setUsuarios(usuariosData);

        const randomMsg =
          MENSAJES[
          Math.floor(Math.random() * MENSAJES.length)
          ];

        toast(randomMsg, {
          icon: "🚀",
          style: {
            borderRadius: "10px",
            background: "#111",
            color: "#fff",
            fontWeight: "bold",
          },
        });
      } catch (error) {
        console.error(
          "❌ Error al obtener usuarios:",
          error
        );
      }
    };

    fetchUsuarios();
  }, [gimnasioActual, tipoRanking]);

  const podio = usuarios.slice(0, 3);
  const resto = usuarios.slice(3);

  return (
    <div className="w-screen min-h-screen bg-gradient-to-br from-gray-950 via-black to-gray-900 text-white">
      <div className="w-full max-w-md mx-auto px-4 pt-5 pb-10">

        {/* CABECERA */}
        <div className="flex items-center justify-between gap-3 mb-6">
          <img
            src={logo}
            alt="RPM Coach"
            className="w-28 h-auto"
          />

          <button
            type="button"
            onClick={() =>
              volverAClase(navigate, user?.uid)
            }
            className="px-4 py-2 rounded-full border border-white/10 bg-white/5 text-sm font-semibold text-gray-300"
          >
            ← Volver
          </button>
        </div>

        {/* TÍTULO */}
        <div className="mb-7 text-center">
          <p className="text-xs uppercase tracking-[0.22em] text-yellow-300 font-bold">
            Ranking mensual
          </p>

          <h1 className="mt-2 text-3xl font-black">
            {tipoRanking === "global"
              ? "Ranking global"
              : gimnasioActual || "Tu grupo"}
          </h1>

          <p className="mt-2 text-sm text-gray-400">
            {tipoRanking === "global"
              ? `Clasificación general · ${mesActual}`
              : `Clasificación de ${gimnasioActual || "tu grupo"} · ${mesActual}`}
          </p>
        </div>

        {/* SIN USUARIOS */}
        {usuarios.length === 0 && (
          <div className="mb-7 rounded-3xl border border-white/10 bg-white/5 p-6 text-center shadow-xl">
            <div className="mx-auto w-14 h-14 flex items-center justify-center rounded-2xl bg-white/10 text-2xl">
              🏆
            </div>

            <h2 className="mt-4 text-lg font-extrabold">
              Todavía no hay clasificación
            </h2>

            <p className="mt-2 text-sm leading-6 text-gray-400">
              {tipoRanking === "global"
                ? "Aún no hay usuarios con puntos en el ranking global."
                : `Aún no hay usuarios con puntos en ${gimnasioActual || "este grupo"
                }.`}
            </p>

          </div>
        )}

        {/* PODIO */}
        {usuarios.length > 0 && (
          <div className="mb-8">
            <div className="flex justify-center items-end gap-3">

              {/* SEGUNDO */}
              {podio[1] && (
                <div className="w-[30%] min-h-[165px] flex flex-col items-center justify-end rounded-3xl border border-gray-300/20 bg-gradient-to-t from-gray-700/80 to-gray-400/30 p-3 text-center shadow-xl">
                  <span className="text-3xl">🥈</span>

                  <div className="mt-3 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 font-black">
                    {podio[1].nombre
                      ?.charAt(0)
                      ?.toUpperCase()}
                  </div>

                  <p className="mt-2 w-full truncate text-sm font-bold">
                    {podio[1].nombre || "Usuario"}
                  </p>

                  <p className="mt-1 text-sm font-extrabold text-gray-200">
                    {podio[1].puntosTotales} pts
                  </p>
                </div>
              )}

              {/* PRIMERO */}
              {podio[0] && (
                <div className="w-[34%] min-h-[205px] flex flex-col items-center justify-end rounded-3xl border border-yellow-300/30 bg-gradient-to-t from-yellow-600/80 to-yellow-300/30 p-3 text-center shadow-2xl">
                  <span className="text-4xl">🥇</span>

                  <div className="mt-3 w-12 h-12 flex items-center justify-center rounded-full bg-yellow-300 text-black font-black">
                    {podio[0].nombre
                      ?.charAt(0)
                      ?.toUpperCase()}
                  </div>

                  <p className="mt-2 w-full truncate text-sm font-black">
                    {podio[0].nombre || "Usuario"}
                  </p>

                  <p className="mt-1 text-base font-black text-yellow-200">
                    {podio[0].puntosTotales} pts
                  </p>
                </div>
              )}

              {/* TERCERO */}
              {podio[2] && (
                <div className="w-[30%] min-h-[150px] flex flex-col items-center justify-end rounded-3xl border border-orange-300/20 bg-gradient-to-t from-orange-800/80 to-orange-400/30 p-3 text-center shadow-xl">
                  <span className="text-3xl">🥉</span>

                  <div className="mt-3 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 font-black">
                    {podio[2].nombre
                      ?.charAt(0)
                      ?.toUpperCase()}
                  </div>

                  <p className="mt-2 w-full truncate text-sm font-bold">
                    {podio[2].nombre || "Usuario"}
                  </p>

                  <p className="mt-1 text-sm font-extrabold text-orange-200">
                    {podio[2].puntosTotales} pts
                  </p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* RESTO DEL RANKING */}
        {resto.length > 0 && (
          <div className="mb-7">
            <div className="flex items-end justify-between mb-3">
              <div>
                <p className="text-xs uppercase tracking-widest text-gray-500">
                  Clasificación
                </p>

                <h2 className="mt-1 text-lg font-extrabold">
                  Resto del pelotón
                </h2>
              </div>

              <span className="text-xs text-gray-500">
                {usuarios.length} ciclistas
              </span>
            </div>

            <div className="space-y-2">
              {resto.map((usuario, index) => (
                <div
                  key={usuario.id}
                  className="flex items-center justify-between gap-3 rounded-2xl border border-white/10 bg-white/[0.07] px-4 py-3 shadow-lg"
                >
                  <div className="min-w-0 flex items-center gap-3">
                    <div className="w-9 h-9 shrink-0 flex items-center justify-center rounded-full bg-white/10 text-sm font-black text-gray-300">
                      {index + 4}
                    </div>

                    <div className="min-w-0">
                      <p className="truncate text-sm font-bold text-white">
                        {usuario.nombre || "Usuario"}
                      </p>

                      <p className="mt-0.5 text-xs text-gray-500">
                        {tipoRanking === "global"
                          ? usuario.nombreGym || "TROTTING"
                          : gimnasioActual || "Tu grupo"}
                      </p>

                    </div>
                  </div>

                  <span className="shrink-0 text-sm font-extrabold text-green-400">
                    {usuario.puntosTotales} pts
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ACCIONES */}
        <div className="grid grid-cols-2 gap-3">
          <button
            type="button"
            onClick={() =>
              volverAClase(navigate, user?.uid)
            }
            className="py-4 rounded-2xl border border-yellow-400/20 bg-yellow-500/10 text-yellow-300 font-bold shadow-lg"
          >
            🚴 Volver
          </button>

          <button
            type="button"
            onClick={handleClase}
            className="py-4 rounded-2xl border border-blue-400/20 bg-blue-500/10 text-blue-300 font-bold shadow-lg"
          >
            📋 Ver canales
          </button>
        </div>

        <div className="mt-5 rounded-3xl border border-white/10 bg-white/5 p-4">
          <p className="mb-2 text-xs uppercase tracking-widest text-gray-500">
            Cuenta
          </p>

          <button
            type="button"
            onClick={handleLogout}
            className="w-full py-3 rounded-xl border border-red-400/10 bg-red-500/5 text-sm font-semibold text-red-400"
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default Ranking;